import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { type BadgeRootProps } from '@rtkwlf/fenrir-react';
import { faCheck } from '@rtkwlf/pro-solid-svg-icons/faCheck';
import type { SecurityFocusState } from '@rtkwlf/track-public';

import type { StatusChipProps } from '@packages/fenrir/components/status-chip/custom-chip';

export type FocusStateToAppearance = {
  [key in SecurityFocusState]: {
    appearance: BadgeRootProps['appearance'];
    icon?: IconDefinition;
    text: string;
    variant: StatusChipProps['variant'];
  };
};

export const focusStateToAppearance: FocusStateToAppearance = {
  'Not Started': {
    appearance: 'default',
    text: 'securityFocuses.focusStatus.notStarted',
    variant: 'unassigned',
  },
  Active: {
    appearance: 'info',
    text: 'securityFocuses.focusStatus.active',
    variant: 'none',
  },
  Paused: {
    appearance: 'danger',
    text: 'securityFocuses.focusStatus.paused',
    variant: 'critical',
  },
  Complete: {
    appearance: 'success',
    icon: faCheck,
    text: 'securityFocuses.focusStatus.complete',
    variant: 'low',
  },
};
